
import store from "@/store";

export default {
  mounted() {
    store.dispatch("OnRouteChange");
  },
  watch: {
    $route() {
      store.dispatch("OnRouteChange");
    },
  },
};
